
/*
*  Utilities used to make API calls
*/

import { NOTIF_TYPE, LOADING_STATE } from "./stateTypes";

/* Used to check the HTTP return status for error codes
*  If it find an error code it will throw the error
*  Otherwise it will propogate the response
*/
const checkStatus = (response) => {
  if (response.status >= 200 && response.status < 300) {
    return response;
  }
  const error = new Error(response.statusText);
  error.response = response;
  throw error;
};

//Does a post request without an auth token
export const postRequest = (url, data, successHandler, errorHandler, timeoutHandler=null) => {
  let headers = {
    "Content-Type": "application/json",
  };

  //Set abort timeout
  // eslint-disable-next-line no-undef
  const controller = new AbortController();
  const signal = controller.signal;
  setTimeout(() => {
    controller.abort();
  }, 15000);

  return fetch(`/api${url}`, {
    method: "POST",
    body: JSON.stringify(data),
    headers,
    signal,
  })
    .then(checkStatus)
    .then(
      //Success
      (response) => {
        return response.json().then(
          (jsonData) => () => successHandler(jsonData), //Could parse json
          () => successHandler,  //Could not parse json
        );
      },
      //Failure
      (error) => {
        if ((timeoutHandler !== null) && signal.aborted) {
          //Request timed out, handle with the timeout handler
          return timeoutHandler;
        }
        if (!error.response) {
          return errorHandler;
        }
        return error.response.json().then(
          (jsonData) => () => errorHandler(jsonData), //Could parse json
          () => errorHandler,  //Could not parse json
        );
      },
    )
    .then((callback) => callback());
};

export const processError = (dispatch, _notif, lsItem=null, callback=null, skipErrorNotif=false) => (
  (errorResponse) => {
    //Check if there is an error response
    if (errorResponse && errorResponse.errors) {
      //Model validation error
      for (let inputName in errorResponse.errors) {
        dispatch(_notif.actions.queueNotification(errorResponse.errors[inputName][0], NOTIF_TYPE.ERROR));
      }
    }
    else if (errorResponse && errorResponse.errorText) {
      //Notify the error text,
      dispatch(_notif.actions.queueNotification(errorResponse.errorText, NOTIF_TYPE.ERROR));
    }
    else {
      //Something broke, show generic error text
      if (!skipErrorNotif) {
        dispatch(_notif.actions.queueNotification("Could not send your message. Please try again, or email us directly.", NOTIF_TYPE.ERROR));
      }
    }
    if (lsItem !== null) {
      dispatch(_notif.actions.setLoadState(lsItem, LOADING_STATE.ERROR));
    }
    if (callback !== null) {
      callback();
    }
  }
);
